import { ScreenDetailed } from '../types';

export function openCustomerView(screen: ScreenDetailed): Window | null {
  // Include left and top in features - Chrome should respect these for Screen Details API
  const features = `left=${screen.left},top=${screen.top},width=${screen.width},height=${screen.height},resizable=no,scrollbars=no,menubar=no,toolbar=no,location=no,status=no`;

  const newWindow = window.open(
    '/customer',
    'CustomerView',
    features
  );

  if (!newWindow) {
    console.error('Failed to open window - popup may be blocked. Please allow popups for this site.');
    alert('Please allow popups for this website to open the customer view.');
    return null;
  }

  // Automatically maximize the window to fit external screen
  // Chrome may restrict moveTo/resizeTo, but we try anyway
  const maximizeWindow = () => {
    try {
      // Check if window is still open
      if (!newWindow || newWindow.closed) {
        return;
      }
      
      // Position and resize to fill the entire external screen
      if (typeof newWindow.moveTo === 'function' && typeof newWindow.resizeTo === 'function') {
        newWindow.moveTo(screen.left, screen.top);
        newWindow.resizeTo(screen.width, screen.height);
        newWindow.focus();
      }
    } catch {
      // Chrome may block this for security - that's expected
    }
  };

  // Try multiple times with delays
  // Chrome may delay applying window features
  setTimeout(maximizeWindow, 0);
  setTimeout(maximizeWindow, 100);
  setTimeout(maximizeWindow, 300);
  setTimeout(maximizeWindow, 500);
  setTimeout(maximizeWindow, 1000);

  // Also try when window loads
  try {
    if (newWindow.document) {
      const checkAndMaximize = () => {
        if (newWindow.document.readyState === 'complete') {
          setTimeout(maximizeWindow, 100);
        } else {
          newWindow.addEventListener('load', () => {
            setTimeout(maximizeWindow, 100);
            setTimeout(maximizeWindow, 500);
          });
        }
      };
      checkAndMaximize();
    }
  } catch {
    // Cross-origin restrictions
  }

  // Send message to trigger fullscreen immediately (while in user interaction context)
  // This works because we're still in the button click event handler
  const triggerFullscreen = () => {
    try {
      if (newWindow && !newWindow.closed) {
        // Use postMessage to trigger fullscreen in the new window
        newWindow.postMessage({ type: 'REQUEST_FULLSCREEN' }, '*');
        
        // Also try to trigger fullscreen directly if possible
        if (newWindow.document && newWindow.document.documentElement) {
          const doc = newWindow.document;
          const elem = doc.documentElement;
          
          if (elem.requestFullscreen) {
            elem.requestFullscreen().catch(() => {});
          } else if ((elem as any).webkitRequestFullscreen) {
            (elem as any).webkitRequestFullscreen();
          } else if ((elem as any).mozRequestFullScreen) {
            (elem as any).mozRequestFullScreen();
          } else if ((elem as any).msRequestFullscreen) {
            (elem as any).msRequestFullscreen();
          }
        }
      }
    } catch {
      // Fullscreen from opener may be blocked
    }
  };

  // Try to trigger fullscreen immediately and after delays
  setTimeout(triggerFullscreen, 0);
  setTimeout(triggerFullscreen, 100);
  setTimeout(triggerFullscreen, 300);
  setTimeout(triggerFullscreen, 500);

  return newWindow;
}
  